import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HealthInsuranceCompany } from '../../../../shared/interfaces';
import { AppSettings } from '../../../../shared/models';
import { AbstractBasicDataApiService } from '../../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class HealthInsuranceCompanyApiService extends AbstractBasicDataApiService<HealthInsuranceCompany> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.employees.healthinsurancecompany);
  }
}
